<template>
    <CDataTable
      :loading="loading"
      class="list-table user_list_table"
      :items="items"
      :fields="fields"
      :column-filter="showColumnFilter"
      :table-filter="showTableFilter"
      :items-per-page-select="showPagination"
      :items-per-page="itemPerPage"
      :hover="showHover"
      :dark="showDark"
      :outlined="showOutlined"
      :border="showBorder"
      :striped="showStriped"
      :sorter="showSorter"
      :pagination="showPagination"
      @row-clicked="handleRowClick"
    >
        <template #user="{item, index}">
            <td>
                <div class="user-avatar" style="justify-content: left;">
                    <Avatar
                        :key="item.user_info.url"
                        :size="30"
                        :src="item.user_info.url" 
                        :username="item.user_info.name" />
                    &nbsp; <span :key="item.refreshKey" :class="{'online-mark' : item.online, 'offline-mark' : !item.online}" ></span>{{item.user_info.name}}
                </div>               
            </td>
        </template>
        <template #strategy_followers="{item, index}">
            <td>
                <div class="action-box" :key="item.followerCount">
                    <div :class="{'action': true, 'selected': item.followers.includes(parseInt(loggedInUser.user_id))}">
                        {{item.followerCount}}
                        <span 
                            v-if="item.userId !== parseInt(loggedInUser.user_id)" 
                            v-c-tooltip="!item.followers.includes(parseInt(loggedInUser.user_id)) ? 'Follow this strategy':'You already followed this strategy'" 
                            @click="item.onFollow(item._id)">
                            <CIcon name="cil-user-follow" />
                        </span>
                        <span v-else>
                            <CIcon name="cil-user-follow" class="disabled" />
                        </span>
                    </div>
                </div>
            </td>
        </template>
      <template #actions="{item, index}">
        <td>
            <template  v-for="(aItem, aIndex) in item.actions">
                <CSwitch
                    v-if="aItem.type == 'switch_stats'"
                    :key="aIndex + strRefreshKey"
                    shape='pill'
                    color="success"
                    class="mx-1"
                    :checked="!item.hide"
                    :disabled="item.notTracked"
                    @update:checked="aItem.funcAction($event, item._id)"
                    v-b-tooltip.hover = "item.hide ? $t('show') : $t('hide')" 
                    style="padding-top: 10px;"
                />
                <CSwitch
                    v-if="aItem.type == 'switch_betfair'"
                    :key="aIndex"
                    shape='pill'
                    color="success"
                    class="mx-1"
                    :checked="item.betfair_status"
                    @update:checked="aItem.funcAction($event, item._id)"
                    v-b-tooltip.hover = "$t('Betfair')"
                    style="padding-top: 10px;"
                />
                <CSwitch
                    v-if="aItem.type == 'switch'"
                    :key="aIndex"
                    shape='pill'
                    color="success"
                    class="mx-1"
                    :checked="item.isFollowed"
                    @update:checked="aItem.funcAction($event, item.user_id)"
                    style="padding-top: 10px;"
                />
                <CSwitch
                    v-if="aItem.type == 'telegram'"
                    :key="aIndex"
                    shape='pill'
                    color="success"
                    class="mx-1"
                    :checked="item.telegram_status"
                    @update:checked="aItem.funcAction($event, item._id)"
                    v-b-tooltip.hover = "$t('Telegram')"
                    style="padding-top: 10px;"
                />
                <CButton
                    v-else-if="aItem.type === 'button'"
                    :key="aIndex"
                    shape="pill"
                    size="sm"
                    :color="aItem.color || 'success'"
                    class="mx-1 detail_button2"
                    :disabled="aItem.disabled"
                    @click="aItem.funcAction(item._id)"
                >
                    {{ aItem.label }}
                </CButton>
                <CSwitch
                    v-if="aItem.type == 'exclude_stats'"
                    :key="aIndex"
                    shape='pill'
                    color="success"
                    class="mx-1"
                    :checked="item.exclude_stats"
                    @update:checked="aItem.funcAction($event, item._id)"
                    v-b-tooltip.hover = "$t('Exclude Stats')"
                    style="padding-top: 10px;"
                />
                <CButton
                    v-if="aItem.type === 'exclude_users'"
                    :key="aIndex"
                    shape="pill"
                    size="sm"
                    :color="aItem.color || 'success'"
                    class="mx-1 detail_button2"
                    :disabled="aItem.disabled"
                    @click="aItem.funcAction(item._id)"
                    v-b-tooltip.hover = "'Excluded ID'"
                >
                    {{ aItem.label + item.exclude_users }}
                </CButton>
                
            </template>
        </td>
      </template>
      <template #strategy_info="{item}">
          <td>
              <span v-c-tooltip="{
                    content: item.description,
                    placement: 'top'
                }">
                <CIcon name="cil-settings" />
              </span>
          </td>
      </template>
      <template #profit_pts="{item}">
          <td v-if=" parseFloat(item.profit_pts) > 0 " style="font-weight: bold; color: green">
              {{ item.profit_pts }}
          </td>
          <td v-else-if=" parseFloat(item.profit_pts) < 0 " style="font-weight: bold; color: red">
              {{ item.profit_pts }}
          </td>
          <td v-else style="font-weight: bold; color: black">
              {{ item.profit_pts }}
          </td>
      </template>
      <template #roi="{item}">
          <td v-if=" parseFloat(item.roi) > 0 " style="font-weight: bold; color: green">
              {{ item.roi }}
          </td>
          <td v-else-if=" parseFloat(item.roi) < 0 " style="font-weight: bold; color: red">
              {{ item.roi }}
          </td>
          <td v-else style="font-weight: bold; color: black">
              {{ item.roi }}
          </td>
      </template>
      <template #w_rate="{item}">
          <td v-if=" parseFloat(item.w_rate) > 0 " style="font-weight: bold; color: green">
              {{ item.w_rate }}
          </td>
          <td v-else-if=" parseFloat(item.w_rate) < 0 " style="font-weight: bold; color: red">
              {{ item.w_rate }}
          </td>
          <td v-else style="font-weight: bold; color: black">
              {{ item.w_rate }}
          </td>
      </template>

    </CDataTable>
</template>

<script>
    
    import { mapGetters } from 'vuex';

    import Avatar from '@/components/Avatar';

    export default {
        components: {            
            Avatar
        },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            fields: {
                type: Array,
                default: () => []
            },
            showColumnFilter: {
                type: Boolean,
                default: false
            },
            showTableFilter: {
                type: Boolean,
                default: true
            },
            itemPerPage: {
                type: Number,
                default: 15
            },
            showHover: {
                type: Boolean,
                default: true
            },
            showDark: {
                type: Boolean,
                default: false
            },
            showOutlined: {
                type: Boolean,
                default: true
            },
            showBorder: {
                type: Boolean,
                default: false
            },
            showStriped: {
                type: Boolean,
                default: false
            },
            showSorter: {
                type: Boolean,
                default: true
            },
            showPagination: {
                type: Boolean,
                default: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            strRefreshKey: {
                type: Number,
                default: 0
            },
            membership_ids: {
                type: Array,
                default: () => []
            },
        },
        computed: {
            ...mapGetters(['loggedInUser'])
        },
        methods: {
            handleRowClick(item, index, columnName, event) {
                if(columnName !== 'actions')
                    this.$emit('row-clicked', item.user_id);
            },
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    .table-responsive {
        margin-top: 20px !important;
    }
    .detail_button2{
        border-radius: 20px;
        margin-top: 1px;
        margin-bottom: 1px;
    }
    .list-table {
        /deep/ table {
            font-weight: 500;
            thead{
                background-color: #f3c421 !important;
            }
            tr {
                cursor: pointer;
                &:hover {
                    td {
                        .user-avatar {
                            color: #39F;
                        }
                    }
                }
                td {
                    .user-avatar {
                        display: flex;
                        color: #321FDB;
                        font-weight: 500;
                        .vue-avatar--wrapper {
                            margin-right: 10px;
                            border: none;
                        }
                    }
                }
                td:nth-child(4), td:nth-child(5), td:nth-child(6){
                    color: #f3c421;
                }
                td:first-child{
                    font-size: 16px !important;
                }
                td{
                    font-size: 14px;
                }
            }
            tr:nth-child(even){
                background-color: #fff8e1;
            }
        }
    }


</style>
<style>
    .table-responsive{
        margin-top: 20px !important;
    }
    .online-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: green;
        border-radius: 50%;
        margin-right: 3px;
    }
    .offline-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: #bec0c2;
        border-radius: 50%;
        margin-right: 3px;
    }
</style>